<template>
    <article class="content">
        <div class="img-ui" :class="{smallImg:smallImg}"><img :src="img" alt=""></div>
        <h4 v-html="title"></h4>
        <slot></slot>
    </article>
</template>
<script>
export default {
    props:{
        img:String,
        title:String,
        smallImg:Boolean
    }
}
</script>
<style lang="scss" scoped>
 .content {
     padding-top: 58px;
    padding-bottom: 98px;
    @include Flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    > .img-ui {
        width: 100px;
        text-align: center;
        &.smallImg {
            width: 70px;
            img {
                width: 100%;
                height: auto;
            }
        }
    }
    > h4 {
        max-width: 684px;
        margin-top: 36px;
        font-size: 16px;
        color: rgba(0,0,0,0.85);
        text-align: center;
        line-height: 26px;
    }
    
 }
</style>




